import { reducers } from 'redux/core'


const setProduct = (product) => reducers.view.postponedPremiumProduct.setProduct(product)

const reset = () => reducers.view.postponedPremiumProduct.reset()


export default {
  setProduct,
  reset,
}
